// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__n+oYF","left":"Switch_left__0ewYZ","right":"Switch_right__iRPaC","active":"Switch_active__ziU6G"};